import React, { useState, useEffect } from 'react';
import { jokeData } from './chuckData';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import logo from './logo512.png';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: 'whitesmoke',
		height: '100vh',
	},

	paperStyle: {
		maxWidth: '600px',
		marginTop: '15%',
		padding: '20px',
		textAlign: 'center',
		letterSpacing: '1.2px',
		lineHeight: '1.2',
		fontSize: '24px',

		[theme.breakpoints.down('xs')]: {
			marginTop: '35%',
			fontSize: '20px',
		},
	},

	jokeWrapper: {
		padding: '20px',
	},

	btnWrapperStyle: {
		marginTop: '20px',
		color: 'red',
	},

	btnStyle: {
		letterSpacing: '1.2px',
		border: '1px solid #d68f53',

		'& span.MuiButton-label': {
			color: '#d68f53',
		},

		'& .MuiButton-outlined': {
			color: '#d68f53',
		},

		width: '215px',
		fontSize: '20px',
		[theme.breakpoints.down('sm')]: {
			margin: '0px 20px 0px 20px',
			maxWidth: '600px',
			fontSize: '18px',
		},
		[theme.breakpoints.down('xs')]: {
			margin: '0px 20px 0px 20px',
			width: '100%',
			fontSize: '16px',
		},
	},

	menuStyle: {
		padding: '20px 10px 20px 10px',
		backgroundColor: '#d68f53',
	},

	imgStyle: {
		width: '50%',
		height: 'auto',
	},

	menuTitle: {
		fontWeight: 600,
		letterSpacing: '1.2px',
		textTransform: 'uppercase',
	},
}));

function App() {
	const classes = useStyles();
	const [randomNr, setRandomNr] = useState(2);

	useEffect(() => {
		randomNumber();
	}, []);
	const randomNumber = async () => {
		var min = 1;
		var max = 618;
		var random = (await Math.floor(Math.random() * (max - min + 1))) + min;
		// console.log(random);
		setRandomNr(random);
	};

	return (
		<div className={classes.root}>
			<AppBar position='static' className={classes.menuStyle}>
				<Box display='flex' justifyContent='center'>
					<Typography variant='h6' className={classes.menuTitle}>
						the ultimative man
					</Typography>
				</Box>
			</AppBar>
			<Box
				display='flex'
				justifyContent='center'
				className={classes.jokeWrapper}
			>
				<Paper className={classes.paperStyle}>
					{jokeData.data[randomNr]?.joke ? (
						jokeData.data[randomNr]?.joke
					) : (
						<img className={classes.imgStyle} src={logo} alt='TUM' />
					)}
				</Paper>
			</Box>
			<Box
				display='flex'
				justifyContent='center'
				className={classes.btnWrapperStyle}
			>
				<Button
					onClick={() => randomNumber()}
					className={classes.btnStyle}
					fullWidth={true}
				>
					Fun Facts
				</Button>
			</Box>
		</div>
	);
}

export default App;
